import IconButton from 'lib/components/buttons/icon-button'
import Button from 'components/core/button'
import { X, Plus, Minus } from 'lucide-react'
import { cn } from 'lib/util/cn'
import { useBillingPlans } from './billing-plans-context'
import { useEffect, useState } from 'react'
import { creativePlan, displayPrice } from 'lib/util/billing'

export default function BillingModalCreativeServices() {
  const { currency, currentPlans, period, plans, selectedPlans, updateSelectedPlans } = useBillingPlans()
  const dailyHours = selectedPlans?.creativePlan?.dailyTime && selectedPlans?.creativePlan?.dailyTime / 60
  const [selectedHours, setSelectedHours] = useState(dailyHours)
  const disabled = !selectedPlans?.platformPlan
  const priceDifference = currentPlans.creativePlan
    ? (+creativePlan(plans, selectedHours * 60)?.price || 0) - (+currentPlans?.creativePlan?.price || 0)
    : +creativePlan(plans, 120)?.price

  useEffect(() => {
    if (selectedHours === 0) {
      updateSelectedPlans(null, 'creative')
      updateSelectedPlans(null, 'professional')
    } else {
      const selectedPlan = creativePlan(plans, selectedHours * 60)
      if (selectedPlan) {
        updateSelectedPlans(selectedPlan, 'creative')
      }
    }
  }, [selectedHours]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={cn(disabled && 'tw-pointer-events-none tw-opacity-50')}>
      <div
        className={cn(
          'tw-mt-2 tw-flex tw-h-[4.5rem] tw-justify-between tw-rounded tw-border tw-border-solid tw-p-4',
          selectedHours > 0 ? 'tw-border-cornflower-300 tw-bg-neutral-50' : 'tw-border-neutral-200',
        )}
      >
        <div className="tw-flex tw-items-center tw-gap-2">
          {selectedHours > 0 && (
            <div className="tw-align-items tw-flex">
              <IconButton
                color="secondary"
                size="xs"
                onClick={() => setSelectedHours(selectedHours === 2 ? 0 : selectedHours - 1)}
                data-testid="minus"
              >
                <Minus />
              </IconButton>
              <div className="tw-w-8 tw-px-2 tw-text-center tw-text-lg">{selectedHours}</div>
              <IconButton
                color="secondary"
                size="xs"
                onClick={() => selectedHours < 12 && setSelectedHours(selectedHours + 1)}
                data-testid="plus"
              >
                <Plus />
              </IconButton>
            </div>
          )}
          <div>
            <div className="tw-font-semibold tw-text-peppercorn-900">Creative services</div>
            <div>
              {dailyHours || 2} daily design hours up to {(dailyHours || 2) * 20} hours per month{' '}
            </div>
          </div>
        </div>
        <div className="tw-flex tw-items-center tw-gap-2">
          {!disabled && currentPlans?.creativePlan?.dailyTime / 60 !== selectedHours && (
            <div>
              <div className="tw-font-semibold tw-text-peppercorn-900">{displayPrice(priceDifference, currency)}</div>
              <div>billed {period}</div>
            </div>
          )}
          {selectedPlans?.creativePlan ? (
            <IconButton color="secondary" onClick={() => setSelectedHours(0)}>
              <X />
            </IconButton>
          ) : (
            <Button
              color="neutral"
              className="tw-ml-2"
              onClick={() => {
                setSelectedHours(2)
              }}
              disabled={disabled}
            >
              <Plus />
              Add
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
